module.exports = __webpack_public_path__ + "img/haijunlan2.6c2c2f2a.png";